// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"ErrorPanel_text-gradient__3idRz","note":"ErrorPanel_note__izJyZ","crossIcon":"ErrorPanel_crossIcon__1mP2F"};